import React from "react";
import { useNavigate } from "react-router-dom";
import OnboardingLayout from "./OnboardingLayout";

const OnboardingComplete = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/profile");
  };

  return (
    <OnboardingLayout currentStep={5} totalSteps={5}>
      <div className="onboarding-form">
        <h1>Onboarding Complete!</h1>
        <p className="subtext">
          Congratulations! You&apos;ve successfully completed the onboarding process.
          You can now start using Folo to its full potential.
        </p>
        
        <button 
          className="submit-button"
          onClick={handleContinue}
        >
          Continue to Profile
        </button>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingComplete;